<i18n>
{
    "de": {
        "reset_instructions": "Um ein neues Passwort zu setzen, bitte hier die E-Mail Adresse eintragen, die beim Studierendenwerk angegeben wurde. Es wird dann eine E-Mail mit einem Link zum Setzten des Passworts dorthin gesendet."
    },
    "en": {
        "reset_instructions": "To reset your password, please enter the Email-Address you provided to Studierendenwerk Karlsruhe. We will then send you an E-Mail with a link to complete the password reset."
    }
}
</i18n>

<template>
    <div class="pw_reset">
        <b-jumbotron :header="$t('system.forgot_pw')">

            <p>{{ $t('reset_instructions')}}</p>
            <b-form @submit="reset_pw">
                <div class="pull-left logincont">
                    <label for="email">{{$t('system.email')}}</label>
                    <input id="email" class="form-control" v-model="email" type="text"/><br/>
                    <button class="btn btn-outline-primary pull-right" type="submit"><i
                            class="fa fa-sign-in" aria-hidden="true"> </i> {{$t('system.request_pw_reset')}}
                    </button>
                </div>
            </b-form>
        </b-jumbotron>
    </div>
</template>

<script>
    import AccountService from '@/api-services/account.service'
    import {EventBus} from '@/eventbus';

    export default {
        name: "forgotPassword",
        data() {
            return {
                email: null,
            }
        },
        methods: {
            reset_pw: async function (ev) {
                ev.preventDefault()
                await AccountService.reset_password(this.email)
                EventBus.$emit('alert', {variant: 'success', message: this.$t("system.password_reset_instructions")})
                this.$emit('alert', {variant: 'success', message: this.$t("system.password_reset_instructions")})
                this.$router.push('/login')
            }
        }
    }
</script>

<style scoped>

</style>
